// extracted by mini-css-extract-plugin
export default {"container":"error-boundary_container__xxlxG"};